// extracted by mini-css-extract-plugin
export default {"innerWrapper":"home_component_innerWrapper__yhsY2"};